/**
 * solfege: Do, Re, Mi, etc...
 * scaleDegrees: 1, 2 ... 7, M7, 8
 * names: 'tonic', 'supertonic', etc...
 * handSigns: fist, palm, etc...
 */
export type SolfegePresentationSystem = 'solfege' | 'scaleDegrees' | 'handSigns' | 'names';
/**
 * The valid scale degree strings '1' through '8'
 */
export type ScaleDegree = '1' | '2' | '3' | '4' | '5' | '6' | 'M6' | '7' | 'M7' | '8';

export const scaleDegrees: ScaleDegree[] = ['1', '2', '3', '4', '5', '6', 'M6', '7', 'M7', '8'];

export function isScaleDegree(scaleDegree: string): scaleDegree is ScaleDegree {
  return scaleDegrees.includes(scaleDegree as ScaleDegree);
}
